import router from "@/router";
import firebase from "firebase";
import {  db, currentCollection } from "@/main";

export const listeners = {
  namespaced: true,

  state: {
    do_unsubscribe: null,
    do_allResults: null
  },

  actions: {
    startListeners({state, dispatch, commit}) {
      if (firebase.auth().currentUser){
      state.do_unsubscribe = currentCollection.doc("game").onSnapshot(doc => {
        // console.log("Current Doc: ", doc.data());
        commit("setCurrentGame", doc.data(), { root: true })
        // this.$store.commit("setCurrentGame", doc.data());
      }, function(error) {
        console.log("Error for currentCollection Listener");
      });

      state.do_allResults = db.collection("results").onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            // console.log("Result Added:  ", change.doc.data());
            dispatch("addResults", {
              ...change.doc.data(),
              resultID: change.doc.id
            }, { root: true });


            // this.$store.dispatch("addResults", {
            //   ...change.doc.data(),
            //   resultID: change.doc.id
            // });
          }
          if (change.type === "modified") {
            // console.log("Result modified: ",change.doc.data());

            dispatch("modifyResults", {
              ...change.doc.data(),
              resultID: change.doc.id
            }, { root: true });


            // this.$store.dispatch("modifyResults", {
            //   ...change.doc.data(),
            //   resultID: change.doc.id
            // });
          }
        });
      }, function(error) {
        console.log("Error for results listener");
      });
    }
    },

    stopListeners({state}) {
      if (firebase.auth().currentUser){
        state.do_unsubscribe();
        state.do_allResults();
        // if (state.do_unsubscribe) state.do_unsubscribe();
        // if (state.do_allResults) state.do_allResults();
      }
    }
  }
}